export const APAY_PAYMENT_CHANNEL = 'inoviopay_applepay';
export const APAY_PAYMENT_TYPE = 'apay';
